import { render, staticRenderFns } from "./IPagination.vue?vue&type=template&id=adeab21e&scoped=true&"
import script from "./IPagination.vue?vue&type=script&lang=js&"
export * from "./IPagination.vue?vue&type=script&lang=js&"
import style0 from "./IPagination.vue?vue&type=style&index=0&id=adeab21e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adeab21e",
  null
  
)

export default component.exports